import { useEffect } from "react";
import { siteConfig } from "../siteConfig";

/*
  Reads siteConfig.chatWidget and injects the script into the page.

  To connect a chat widget for a new contractor:
    1. Get the embed <script> tag from their chat platform (GoHighLevel, Tidio, Intercom, etc.)
    2. In siteConfig.js set:
         chatWidget: {
           src: "https://...",          // the script src URL
           attrs: {                     // any data-* attributes the script needs
             "data-widget-id": "abc123",
             "data-resources-url": "https://...",
           },
         }
    3. Save — the widget loads automatically on all pages.

  Leave chatWidget.src as "" to disable the widget entirely.
*/
const ChatWidgetLoader = () => {
  useEffect(() => {
    const { src, attrs = {} } = siteConfig.chatWidget || {};
    if (!src) return;

    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    Object.entries(attrs).forEach(([key, val]) => script.setAttribute(key, val));
    document.body.appendChild(script);

    return () => {
      if (script.parentNode) script.parentNode.removeChild(script);
    };
  }, []);

  return null;
};

export default ChatWidgetLoader;
